import React, { useCallback, useState } from "react";

import {
  Dialog,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@material-ui/core";
import { LoadingButton } from "@material-ui/lab";
import { empleadosApi } from "src/services/empleadosApi";
import { useSnackbar } from "src/components/snackbar";

export default function EditarBitacora(props) {
  const { open, setOpen, bitacora, empleado } = props;

  const [descripcionBitacora, setDescripcionBitacora] = useState(
    bitacora.descripcion,
  );
  const [
    actualizarBitacoraEmpleado,
    { isLoading: actualizandoBitacoraEmpleado },
  ] = empleadosApi.useUpdateBitacoraEmpleadoMutation();

  const { enqueueSnackbar } = useSnackbar();

  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeDescripcion = (event) => {
    setDescripcionBitacora(event.target.value);
  };

  const guardarDatos = useCallback(async () => {
    try {
      const body = {
        refUsuario: empleado.rut,
        descripcion: descripcionBitacora,
        fecha: bitacora.fecha,
      };
      await actualizarBitacoraEmpleado(body).unwrap();
      enqueueSnackbar("Bitácora actualizada correctamente", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      });
      setOpen(false);
    } catch (error) {
      enqueueSnackbar(
        error?.data?.message ||
          error.message ||
          "Ocurrió un error al actualizar la bitácora",
        {
          variant: "error",
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
        },
      );
    }
  }, [
    actualizarBitacoraEmpleado,
    bitacora?.fecha,
    descripcionBitacora,
    empleado?.rut,
    enqueueSnackbar,
    setOpen,
  ]);

  const cerrar = () => {
    handleClose();
  };

  return (
    <>
      <div>
        <Dialog open={open} fullWidth maxWidth="md">
          <DialogTitle id="form-dialog-title">Editar Bitácora</DialogTitle>
          <DialogContent>
            <TextField
              value={descripcionBitacora}
              onChange={handleChangeDescripcion}
              required
              autoFocus
              multiline
              margin="dense"
              label="Descripción"
              fullWidth
              rows={10}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={cerrar}>Cerrar</Button>
            <LoadingButton
              loading={actualizandoBitacoraEmpleado}
              onClick={guardarDatos}
              variant="contained"
            >
              Editar
            </LoadingButton>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}
